"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingHistoryRow = void 0;
var React = __importStar(require("react"));
var _ = __importStar(require("lodash"));
var deltaArrowNumber_1 = require("./deltaArrowNumber");
var rankingUtil_1 = require("./rankingUtil");
var N_YEARS_TO_SHOW = 6;
exports.RankingHistoryRow = function (props) {
    var ranks = props.ranks, latestYear = props.latestYear;
    var years = rankingUtil_1.getAvailableYears(ranks);
    return (React.createElement("div", { className: "total" },
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { className: "title" },
                        "Totalranking ",
                        latestYear,
                        ": ",
                        ranks[latestYear],
                        " (",
                        React.createElement(deltaArrowNumber_1.DeltaArrowNumber, { ranks: ranks, latestYear: latestYear }),
                        ")"),
                    _.chain(years).takeRight(N_YEARS_TO_SHOW).dropRight(1).map(function (year) {
                        return (React.createElement("td", { key: year },
                            React.createElement("strong", null, year),
                            React.createElement("span", null, ranks[year])));
                    }).value())))));
};
